export const CONTENTFUL = {
  DEFAULT: '6MgVG0QxET8ncbtytftFEF',
  'KOREA (THE REPUBLIC OF)': '3GifomSFgeyL4hbbDIM3rl',
  'JAPAN': '29EQIDNJ8l0xkS4iIj7nVk',
  marketingOptIn: '4WMUWK4DvINgUt5CSQvyID',
};
